import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly baseUrl = environment.apiUrl;
  private readonly defaultHeaders = new HttpHeaders({ Accept: 'application/json' });

  constructor(private httpClient: HttpClient) {}

  private handleError(error: any): Observable<never> {
    return throwError(() => error);
  }

  private getJsonHeaders(): HttpHeaders {
    return this.defaultHeaders.set('Content-Type', 'application/json');
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.httpClient
      .get(`${this.baseUrl}${path}`, { headers: this.getJsonHeaders(), params, withCredentials: true })
      .pipe(catchError(error => this.handleError(error)));
  }

  post(path: string, body: any = {}): Observable<any> {
    const headers = body instanceof FormData ? this.defaultHeaders : this.getJsonHeaders();
    return this.httpClient
      .post(`${this.baseUrl}${path}`, body, { headers, withCredentials: true })
      .pipe(catchError(error => this.handleError(error)));
  }

  put(path: string, body: any = {}): Observable<any> {
    const headers = body instanceof FormData ? this.defaultHeaders : this.getJsonHeaders();
    return this.httpClient
      .put(`${this.baseUrl}${path}`, body, { headers, withCredentials: true })
      .pipe(catchError(error => this.handleError(error)));
  }

  patch(path: string, body: any = {}): Observable<any> {
    const headers = body instanceof FormData ? this.defaultHeaders : this.getJsonHeaders();
    return this.httpClient
      .patch(`${this.baseUrl}${path}`, body, { headers, withCredentials: true })
      .pipe(catchError(error => this.handleError(error)));
  }

  delete(path: string): Observable<any> {
    return this.httpClient
      .delete(`${this.baseUrl}${path}`, { headers: this.getJsonHeaders(), withCredentials: true })
      .pipe(catchError(error => this.handleError(error)));
  }
}
